import React from 'react';
import { HeartHandshakeIcon } from 'lucide-react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
const inputClass = 'w-full h-12 px-4 text-[15px] border-[1.5px] border-[#e0e0e0] rounded-lg outline-none focus:border-primary transition-colors';
const labelClass = 'block text-sm font-semibold text-[#333] mb-1.5';
const helpOptions = ['Orientación nutricional', 'Acceso a especialistas biomédicos', 'Apoyo educativo', 'Recursos y materiales', 'Apoyo emocional para la familia', 'Otro'];
export function SolicitarAyuda() {
  useDocumentMeta({
    title: 'Solicitar Ayuda | Pancita Feliz Foundation',
    description: 'Solicita apoyo de Pancita Feliz Foundation. Ayudamos a familias con recursos limitados a acceder a educación y abordajes biomédicos.',
    path: '/solicitar-ayuda'
  });
  return <main className="w-full" data-id="element-360" data-mp="1eujchaqtpug">
      {/* Hero */}
      <section className="text-center px-4 py-16" style={{
      background: '#f0f7e6'
    }} data-id="element-361" data-mp="3smgu0tvvqskt">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/15 rounded-full mb-5" data-id="element-362" data-mp="do4uexpl8lkd">
          <HeartHandshakeIcon className="w-8 h-8 text-primary" data-id="element-363" data-mp="ig68mp6bgmd1" />
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-[#1a1a1a] mb-4" data-id="element-364" data-mp="3qqldj5zuz23">
          Solicita Ayuda
        </h1>
        <p className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-365" data-mp="8qd1c0d7itel">
          Completa el formulario y nuestro equipo se pondrá en contacto contigo.
        </p>
      </section>

      {/* Form */}
      <section className="px-4 py-12 bg-white" data-id="element-366" data-mp="11e8wh0n4od99">
        <div className="mx-auto bg-white" style={{
        maxWidth: '680px',
        borderRadius: '16px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        padding: '48px'
      }} data-id="element-367" data-mp="11bwdck5mvwum">
          <form action="https://formspree.io/f/mjgqrwbz" method="POST" data-id="element-368" data-mp="376fj21by33pr">
            <input type="hidden" name="_replyto" value="info@pancitafelizfoundation.org" data-id="element-369" data-mp="3c60jyhaodm54" />
            <input type="hidden" name="_subject" value="🌱 Nueva Solicitud de Ayuda - Pancita Feliz Foundation" data-id="element-370" data-mp="1im9twqxkqc3y" />

            <h2 className="text-[22px] font-bold text-[#1a1a1a] mb-8" data-id="element-371" data-mp="18x8a0pnwrakp">
              Información de la Familia
            </h2>

            {/* Personal info */}
            <p className="text-xs font-bold tracking-widest uppercase text-primary mb-4" data-id="element-372" data-mp="13waxaslo38ql">
              Información Personal
            </p>

            <div className="mb-5" data-id="element-373" data-mp="ux7bhgv48f8e">
              <label className={labelClass} data-id="element-374" data-mp="uw5p4g8ng6bd">
                Nombre completo del padre/madre/tutor
              </label>
              <input type="text" name="nombre_completo" required placeholder="Tu nombre completo" className={inputClass} data-id="element-375" data-mp="q0qdluy46mi4" />
            </div>

            <div className="mb-5" data-id="element-376" data-mp="2fd29lngli257">
              <label className={labelClass} data-id="element-377" data-mp="2feveoybk8eb3">Correo electrónico</label>
              <input type="email" name="email" required placeholder="correo@ejemplo.com" className={inputClass} data-id="element-378" data-mp="2mxmjn7n92sh5" />
            </div>

            <div className="mb-5" data-id="element-379" data-mp="2wo7h2rr6tqyh">
              <label className={labelClass} data-id="element-380" data-mp="2wp8u31rrkniu">
                Número de teléfono / WhatsApp
              </label>
              <input type="tel" name="telefono" required placeholder="+1 (000) 000-0000" className={inputClass} data-id="element-381" data-mp="23y8qgrxchlrp" />
            </div>

            <div className="mb-5" data-id="element-382" data-mp="2dw57u1gvlcy9">
              <label className={labelClass} data-id="element-383" data-mp="2dv3koyml5006">País de residencia</label>
              <select name="pais" required className={inputClass} defaultValue="" data-id="element-384" data-mp="2iwj64rsod8j3">
                <option value="" disabled data-id="element-385" data-mp="3uamyjtjm6om1">
                  Selecciona tu país
                </option>
                <option data-id="element-386" data-mp="3rvq7l9lypp8c">Venezuela</option>
                <option data-id="element-387" data-mp="3rwrm5o26stut">Colombia</option>
                <option data-id="element-388" data-mp="3rxt6kj53esp7">México</option>
                <option data-id="element-389" data-mp="3nv6dyg0ll3qy">Estados Unidos</option>
                <option data-id="element-390" data-mp="3nwhhceq4s9hj">España</option>
                <option data-id="element-391" data-mp="5pb7f3ucrzsc">Otro</option>
              </select>
            </div>

            {/* About the child */}
            <p className="text-xs font-bold tracking-widest uppercase text-primary mb-4 mt-8" data-id="element-392" data-mp="pfafok2p8ma">
              Sobre el Niño/a
            </p>

            <div className="mb-5" style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '16px'
          }} data-id="element-393" data-mp="endf228ldqol">
              <div data-id="element-394" data-mp="oh3yuttrxcxy">
                <label className={labelClass} data-id="element-395" data-mp="jgg7g71muu37">Nombre del niño/a</label>
                <input type="text" name="nombre_nino" required placeholder="Nombre del niño o niña" className={inputClass} data-id="element-396" data-mp="jiiy8tam0r8z" />
              </div>
              <div data-id="element-397" data-mp="1d17e0t24kavl">
                <label className={labelClass} data-id="element-398" data-mp="1d0nvpb8kbkh1">Edad del niño/a</label>
                <input type="number" name="edad_nino" required placeholder="Edad en años" className={inputClass} data-id="element-399" data-mp="1h2115k7qtlnf" />
              </div>
            </div>

            <div className="mb-5" data-id="element-400" data-mp="182w30f03fubs">
              <label className={labelClass} data-id="element-401" data-mp="tbna9x0w9suf">
                Diagnóstico actual (si tiene)
              </label>
              <input type="text" name="diagnostico" placeholder="Ej: TEA, TDAH, retraso del desarrollo, sin diagnóstico..." className={inputClass} data-id="element-402" data-mp="y3x3pn17xb1g" />
            </div>

            <div className="mb-5" data-id="element-403" data-mp="p8h04eanvhio">
              <label className={labelClass} data-id="element-404" data-mp="acstkihveibm">
                ¿Cuánto tiempo lleva buscando ayuda?
              </label>
              <select name="tiempo_buscando" required className={inputClass} defaultValue="" data-id="element-405" data-mp="fbcf4hsjxs3g">
                <option value="" disabled data-id="element-406" data-mp="3nlwuatrvjn5e">
                  Selecciona una opción
                </option>
                <option data-id="element-407" data-mp="3imk88b8tuk3v">Menos de 6 meses</option>
                <option data-id="element-408" data-mp="3il942abgzac8">Entre 6 meses y 1 año</option>
                <option data-id="element-409" data-mp="3dp1yiimzk0ut">Entre 1 y 3 años</option>
                <option data-id="element-410" data-mp="3dm606t787a5u">Más de 3 años</option>
              </select>
            </div>

            {/* Current situation */}
            <p className="text-xs font-bold tracking-widest uppercase text-primary mb-4 mt-8" data-id="element-411" data-mp="a7tg9xociyzk">
              Situación Actual
            </p>

            <div className="mb-6" data-id="element-412" data-mp="575qffbuso6x">
              <label className={labelClass} data-id="element-413" data-mp="5aa2szzh2q8o">¿Qué tipo de ayuda necesita?</label>
              <div className="grid sm:grid-cols-2 gap-3 mt-2" data-id="element-414" data-mp="949p11wh0ym">
                {helpOptions.map(option => <label key={option} className="flex items-center gap-3 cursor-pointer text-[15px] text-[#333]" data-id="element-415" data-mp="2pwle41frzwsc">
                    <input type="checkbox" name="tipo_ayuda" value={option} className="w-5 h-5 accent-primary" data-id="element-416" data-mp="10j5alegj104o" />
                    {option}
                  </label>)}
              </div>
            </div>

            <div className="mb-5" data-id="element-417" data-mp="1f89vj3ephigh">
              <label className={labelClass} data-id="element-418" data-mp="1k6bcniskn7pb">Cuéntanos tu situación</label>
              <textarea name="situacion" required rows={5} placeholder="Describe brevemente la situación de tu familia y cómo podemos ayudarte..." className="w-full px-4 py-3 text-[15px] border-[1.5px] border-[#e0e0e0] rounded-lg outline-none focus:border-primary transition-colors resize-none" data-id="element-419" data-mp="1o74ym6mgecfk" />
            </div>

            <div className="mb-8" data-id="element-420" data-mp="3r1osbgl7q95">
              <label className={labelClass} data-id="element-421" data-mp="3s310j9caisg">
                ¿Cómo se enteró de Pancita Feliz Foundation?
              </label>
              <select name="como_entero" required className={inputClass} defaultValue="" data-id="element-422" data-mp="25mr22yuf2qzw">
                <option value="" disabled data-id="element-423" data-mp="2fdbyqgqj5lg6">
                  Selecciona una opción
                </option>
                <option data-id="element-424" data-mp="2ag2ctb2cnrx3">Redes sociales</option>
                <option data-id="element-425" data-mp="1mpzjkrmp8fww">Recomendación de un amigo</option>
                <option data-id="element-426" data-mp="1mqhp6ev946hh">Médico o terapeuta</option>
                <option data-id="element-427" data-mp="1hreloyux68bm">Búsqueda en internet</option>
                <option data-id="element-428" data-mp="1hspnit4t1603">Otro</option>
              </select>
            </div>

            <button type="submit" className="w-full text-white font-bold rounded-xl transition-colors hover:bg-[#6ab518]" style={{
            height: '52px',
            fontSize: '16px',
            background: '#7DC920'
          }} data-id="element-429" data-mp="1wox8vwry8dgy">
              Enviar Solicitud
            </button>

            <p className="text-center mt-4" style={{
            fontSize: '12px',
            color: '#888'
          }} data-id="element-430" data-mp="3ao0ce8adibj4">
              🔒 Tu información es confidencial y será tratada con total
              privacidad
            </p>
          </form>
        </div>
      </section>
    </main>;
}